module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltySpring@2x.aae56f7b.png";